import { LogoSetItem } from '@oneappexchange/oaf-schema';

export const images = {
    get errorBird() {
        return `/images/search/error.svg`;
    },
    get errorEmptyState() {
        return `/images/errors/empty_state.svg`;
    },
    get cookiePreferences() {
        return `/images/rtaImage.jpeg`;
    },
    get noFiltersApplied() {
        return `/images/search/seagull_cloud.png`;
    },
    get simplifiedTrialsHeader() {
        return `/images/appy_2.png`;
    },
    get ordersEmptyState() {
        return `/images/orders/empty_state.svg`;
    },
    get tryListingSummaryDecoration() {
        return `/images/try/summary_decoration.png`;
    },
    get tryConfirmationAppy() {
        return `/images/try/confirmation_appy.png`;
    },
    get emptyImgSrc() {
        return `/images/search/error.svg`;
    },
    get illustrationBirdLogo() {
        return '/images/orders/illustration-bird-log.png';
    },
};

export const getListingLogoMediaId = (logos: LogoSetItem[]): string | undefined => {
    return logos.find((logo) => logo.logoType === 'Logo')?.mediaId;
};
